import React from 'react'

function homeassignments() {
  return (
    <div>
    <div className="ib-home-assignment">
      <h1>Home Assignment</h1>
      <p></p>



    </div>
    </div>
  )
}

export default homeassignments
